import { faFilter } from "@fortawesome/fontawesome-free-solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { OverlayTrigger, Popover, Tooltip } from "react-bootstrap";
import { Link } from "react-router-dom";
import "../../../assets/css/site.min.css";
import "../../../assets/css/site.override.css";
import "../../../assets/fonts/web-icons/web-icons.min.css";
import "../../../assets/fonts/7-stroke/7-stroke.min.css";
import "../../../assets/fonts/open-iconic/open-iconic.min.css";
import { TemplateHeader, TemplateMenu } from "../../RemarkTemplate";
import UserHelp from "../../util/UserHelp";
import TemplateFooter from "../Footer";
import { getTheme } from "../../../constants/getTheme";

export function HeaderFilterButton({
  active,
  icon = faFilter,
  message = "Filter",
  render: Component = () => {
    <div></div>;
  },
  componentProps = {},
  children,
  theme,
  isButtonIcon = true,
  text = "",
}) {
  return (
    <HeaderButton
      icon={icon}
      message={message}
      active={active}
      popOverContent={
        <>
          <UserHelp>
            Dear user, you can dismiss this window <br />
            by clicking outside of it.
          </UserHelp>
          {children || <Component {...componentProps} />}
        </>
      }
      theme={theme}
      isButtonIcon={isButtonIcon}
      text={text}
    />
  );
}

export function HeaderButton({
  icon,
  message,
  active = false,
  popOverContent = null,
  disabled = false,
  children,
  onClick = () => {},
  theme = null,
  isButtonIcon = true,
  text,
}) {
  const overlayOptions = popOverContent
    ? {
        trigger: "click",
        placement: "bottom-end",
        rootClose: true,
        overlay: (
          <Popover style={{ maxWidth: "500px" }} id="popover-basic">
            <Popover.Title as="h3">{message}</Popover.Title>
            <Popover.Content>{popOverContent}</Popover.Content>
          </Popover>
        ),
      }
    : {
        placement: "top",
        overlay: <Tooltip>{message} </Tooltip>,
      };

  const button = (
    <button
      type="button"
      className={`${theme?.selectClass} btn-sm ${
        isButtonIcon
          ? "  btn-round btn-icon btn-inverse"
          : "inline-flex gap-2 items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 bg-primary text-primary-foreground hover:bg-primary/90 !h-10 !px-4 !py-2 !bg-teal-600 hover:bg-teal-800 text-white !rounded-xl !h-9"
      }  `}
      style={{
        backgroundColor: active ? theme?.circleButton : "",
        color: active ? theme?.white : "",
      }}
      data-toggle="tooltip"
      data-original-title={message}
      disabled={disabled}
      onClick={() => {
        onClick && onClick();
      }}
    >
      {icon ? <FontAwesomeIcon icon={icon} /> : children}{" "}
      {!isButtonIcon && text}
    </button>
  );

  return !disabled ? (
    <OverlayTrigger delay={{ show: 250, hide: 100 }} {...overlayOptions}>
      {button}
    </OverlayTrigger>
  ) : (
    button
  );
}

export function BreadCumb({ path, displayName, active, theme }) {
  return (
    <li className={"breadcrumb-item " + (active ? "active" : "")}>
      {active && displayName}
      {!active && (
        <Link to={path} style={{ color: active ? "" : theme.primary }}>
          {displayName}
        </Link>
      )}
    </li>
  );
}

const TemplateBody = ({
  noWrapped,
  showAsideMenu,
  setShowAsideMenu,
  showDropDownUserMenu,
  setShowDropDownUserMenu,
  showDotsMenu,
  setShowDotsMenu,
  activePage,
  breadCumbs = [],
  headerButtons = [],
  className,
  ...props
}) => {
  const theme = getTheme(process.env.REACT_APP_CLIENT_THEME);
  return (
    <section
      className={`animsition site-menubar-keep ${
        showAsideMenu
          ? "site-menubar-unfold site-menubar-open"
          : "site-menubar-fold site-menubar-hide"
      } ${className}`}
    >
      <TemplateHeader
        showDropDownUserMenu={showDropDownUserMenu}
        showDotsMenu={showDotsMenu}
        showAsideMenu={showAsideMenu}
        setShowAsideMenu={() => {
          if (!showAsideMenu) {
            setShowDotsMenu(false);
          }
          setShowAsideMenu(!showAsideMenu);
        }}
        showFullSizeLogo={!showAsideMenu}
        setShowDropDownUserMenu={() => {
          setShowDropDownUserMenu(!showDropDownUserMenu);
        }}
        setShowDotsMenu={() => {
          if (!showDotsMenu) {
            setShowAsideMenu(false);
          }
          setShowDotsMenu(!showDotsMenu);
        }}
        activePage={activePage}
        theme={theme}
      />
      <TemplateMenu
        isDesktop={true}
        activeItem={activePage && activePage.path}
        isMobile={false}
        show={showAsideMenu}
        menuIsCollapsed={!showAsideMenu}
        theme={theme}
      />
      <div className="page">
        <div
          className="page-header"
          style={{ display: breadCumbs.length > 0 ? "block" : "none" }}
        >
          <h1 className="page-title" style={{ color: theme.pageTitleColor }}>
            {props.title}
          </h1>
          <ol className="breadcrumb mt-3 mb-0">
            {breadCumbs.map((x) => (
              <BreadCumb key={x.path} {...x} theme={theme} />
            ))}
            {activePage && <BreadCumb {...activePage} active theme={theme} />}
          </ol>
          <div className="page-header-actions" style={{ display: "flex" }}>
            {headerButtons}
          </div>
        </div>

        <div className="page-content">{props.children}</div>
      </div>
      <TemplateFooter />
    </section>
  );
};
export default TemplateBody;
